import { ChartAxis, ChartSerie } from "./common-chart";

export class WaterfallChartDatasource {
  zoomInfo: any;
  title: string;
  series: ChartSerie[];
  axisX: ChartAxis;
  axisY: ChartAxis;
  xValues: number[];
  xLabels: string[];
}
